import { Record } from 'immutable';
import { UserType } from '../types';
import Util from '../util';

export type ApiUser = {
  name: string;
  user_type: UserType;
  user_no: number;
  active_in_hour: number;
  last_activity_on: string;
};

const UserBase = Record({
  name: "",
  userType: "" as UserType,
  userNo: 0,
  activeInHour: 9999,
  lastActivityOn: "",
});

export class User extends UserBase {
  constructor(apiUser?: ApiUser) {
    super({
      name: apiUser?.name,
      userType: apiUser?.user_type,
      userNo: apiUser?.user_no,
      activeInHour: apiUser?.active_in_hour,
      lastActivityOn: apiUser?.last_activity_on,
    })
  }

  readonly initialName: string = this.name.split('').join('.');

  readonly activeInText: string = Util.toActiveInWord(this.activeInHour);
}
